$(function () {
  if (
    window.saso_extras.product &&
    window.saso_extras.product.variants.length > 1 &&
    window.saso_extras.product.id != 1117949460524
  ) {
    $ = jQuery;

    var arr = window.saso_extras.product.variants;
    var curVarientsEl = document.querySelectorAll(
      ".SizeSwatchList.HorizontalList.HorizontalList--spacingTight label"
    );

    // Polyfill for forEach on Nodelist - IE
    if (window.NodeList && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = Array.prototype.forEach;
    }

    // Loop through variants to calculate discounts and apply badges only to '1 Year' variants
    $.each(arr, function (index, value) {
      // Ensure the variant title is being checked properly (case-sensitive check for '1 Year')
      if (value.title && value.title.includes("1 Year")) {
        var price = (value.price / 100).toFixed(2);
        var comparePrice = (value.compare_at_price / 100).toFixed(2);
        var saving =
          comparePrice == 0
            ? 0
            : ((comparePrice - price) / comparePrice) * 100;
        var roundedDiscount = saving == 0 ? 0 : parseFloat(saving.toFixed(1));

        // Only apply the savings badge if there is a discount
        if (roundedDiscount > 0) {
          // Loop through the elements and add the savings badge to the correct variant
          curVarientsEl.forEach(function (variant, i) {
            if (index == i) {
              variant.innerHTML =
                variant.innerHTML +
                '<span class="your-savings"> Save ' +
                roundedDiscount +
                "% </span>";
            }
          });
        }
      }
    });
  }
});
